// @flow
import { defineMessages } from 'react-intl'

// Constants
import {
  MSG_REOPEN_JOB_SIDEBAR_HEADING,
  MSG_REOPEN_JOB_SIDEBAR_MESSAGE,
  MSG_REOPEN_JOB_SIDEBAR_REOPEN_BTN,
  MSG_REOPEN_JOB_SIDEBAR_CANCEL_BTN,
} from 'hfty-reopen-job-dom'

export default defineMessages({
  [MSG_REOPEN_JOB_SIDEBAR_HEADING]: {
    id: 'reopenJob.sidebarHeading',
    defaultMessage: 'Reopen Job',
  },
  [MSG_REOPEN_JOB_SIDEBAR_MESSAGE]: {
    id: 'reopenJob.sidebarMessage',
    defaultMessage: 'Please sync this job from your mobile device to ensure that all data is saved ' +
    'before editing this field or job.',
  },
  [MSG_REOPEN_JOB_SIDEBAR_REOPEN_BTN]: {
    id: 'reopenJob.sidebarReopenButton',
    defaultMessage: 'Reopen Job',
  },
  [MSG_REOPEN_JOB_SIDEBAR_CANCEL_BTN]: {
    id: 'reopenJob.sidebarCancelButton',
    defaultMessage: 'Cancel',
  },
})
